module.exports = __webpack_public_path__ + "static/media/pizza.2d9ac3be.svg";